module.exports = __webpack_public_path__ + "img/member_desktop.2effa6ae.png";